
  import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
  import { HTTP } from "@/axios_api/http-common";
  import DailyReportViewer from "./DailyReportViewer";
  import UserProvisioning from '@/mixins/userProvisioning';
  @Component ({
    components: {
      "report-viewer": DailyReportViewer
    },    
    filters: {
      prettyttime(dateTime: any) {
        let passedDate = new Date(Date.parse(dateTime));
        return (
          (passedDate.getHours() < 10
            ? "0" + (passedDate.getHours())
            : (passedDate.getHours())) +
          ":" +
          (passedDate.getMinutes() < 10
            ? "0" + passedDate.getMinutes()
            : passedDate.getMinutes())
        );
      },
    },
  })
  export default class OverviewDDR extends Mixins(UserProvisioning) {
    @Prop({})
    projectId !: any
    sendingSelected: any[] = []
    searchSelected: string = ""
    searchAll: string = ""
    fields: any[] = [
      { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }, },
      { key: 'serial', label: 'S/N', sortable: false },
      // { key: "id", label: "Report No." },
      { key: "Activity", label: "Activity" },
      { key: "reportDate", label: "Report Date", },
      { key: "reportUploadDate", label: "Upload Date" },
      { key: "startTime", label: "Time Start", },
      { key: "endTime", label: "Time End", },
      { key: "manHours", label: "Man Hours" },
      { key: "nptHours", label: "NPT Hours" },
      { key: "startDepth", label: this.$store.state.UnitsModule.currentUnitSystem == 'si' ? 'Start Depth(m)': 'Start Depth(ft)', },
      { key: "endDepth", label: this.$store.state.UnitsModule.currentUnitSystem == 'si' ? 'End Depth(m)': 'End Depth(ft)',  },
      { key: "actions", label: "Actions" },
    ]
    selectedRows: {id: string;}[] = []
    selectAll: boolean = false
    selectedDailyReport: any = {}
    deletePromptProperty: boolean = false
    selectedReportId: number = 0
    send: boolean = false
    emails: any[] = []
    selectedEmails: any[] = []
    showModal: boolean = false
    getTimeDifferenceInHours(startDateTime: string, endDateTime: string) {
      let passedStartDate = new Date(Date.parse(startDateTime)).getTime();
      let passedEndDate = new Date(Date.parse(endDateTime)).getTime();
      if(passedEndDate<= passedStartDate){
        passedEndDate = passedEndDate+(24*3600*1000);
      }
      return Math.round(Math.abs(passedEndDate - passedStartDate) / (1000 * 3600));
    }

    getNPTHours(activityLogs: Array<any>) {
      return activityLogs.reduce((sum, log) => {
        if (log.hasNpt && log.npt) {
          return sum + (log.npt.nptHours || 0);
        }
        return sum;
      }, 0);
    }

    viewDailyReporClicked(id: any) {
      this.selectedDailyReport = this.ddrs.find((d) => d.id == id);
      if (!this.selectedDailyReport.selectedViews) {
          this.selectedDailyReport.selectedViews = ['General', 'Activity Logs', 'Cost and AFE Summary'];
      }
      this.showModal = true
      // this.$bvModal.show("reportviewermodal");
    }
    printDailyReport(id: any) {
      if (id.length > 0) {
        HTTP.get("ddr/exportDocument?dailyReportId="+id, { responseType: "blob" })
          .then((res: any) => {
            var blob = new Blob([res.data], {
              type: res.headers["content-type"],
            });
            const link = document.createElement("a");
            const downloadUrl = window.URL.createObjectURL(blob);
            link.href = downloadUrl;
            //link.download = res.headers.filename
            link.setAttribute("download", res.headers.filename + ".xlsx"); //any other extension
            document.body.appendChild(link);
            link.click();
           // link.remove();
          })
          .catch((error: any) => {});
      } else {
        alert("invalid id");
      }
    }
    OpenEmailList(selectedReportId: number) {
      this.send = true;
      this.selectedReportId = selectedReportId;
    }
    emailDailyReport() {
      let emailsToSendTo = this.sendingSelected.map((x: any) => {
        return x.userEmail;
      });
      let recipientIds = this.selectedEmails.map((x: any) => {
        return x.id;
      });
      this.$bvToast.toast('Please wait while this daily report is being delivered to the specified emails.', {
        title: 'Loading',
        autoHideDelay: 3000,
        appendToast: true,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: 'dark'
      })
      HTTP.post("ddr/distribute", {
        reportId: this.selectedReportId,
        recipients: emailsToSendTo,
      }).then((res:any) => {
        this.$bvToast.toast('This Daily Report has been delivered to the corresponding email addresses.', {
            title: 'Successful!!!',
            autoHideDelay: 10000,
            appendToast: true,
            toaster: 'b-toaster-bottom-right',
            solid: true,
            variant: 'success'
          })
      }).catch((err: any) => {
            this.$bvToast.toast('This daily report failed to deliver.', {
            title: 'Failed!!!',
            autoHideDelay: 10000,
            appendToast: true,
            toaster: 'b-toaster-bottom-right',
            solid: true,
            variant: 'danger'
          })
        });
      HTTP.post("reportrecipient/upsert", {
        projectId: this.projectId,
        RecipientIds: recipientIds,
      });
    }
    getUsers() {
      return this.$store.dispatch("usersModule/getUsers");
    }
    fetchReportRecipients() {
      return this.$store.dispatch(
        "DailyReportModule/getReportRecipient",
        this.projectId
      );
    }
    addUser(user: any) {
      let ind: any = this.emails.findIndex((x: any) => x.id === user.id);
      this.selectedEmails.push({
        id: this.emails[ind].id,
        userEmail: this.emails[ind].userEmail,
      });
      this.sendingSelected.push({
        id: this.emails[ind].id,
        userEmail: this.emails[ind].userEmail,
      });
      this.emails.splice(ind, 1);
    }
    removeUser(user: any) {
      let ind: any = this.selectedEmails.findIndex(
        (x: any) => x.id === user.id
      );
      let inds: any = this.sendingSelected.findIndex(
        (x: any) => x.id === user.id
      );
      this.emails.push({
        id: this.selectedEmails[ind].id,
        userEmail: this.selectedEmails[ind].userEmail,
      });
      this.selectedEmails.splice(ind, 1);
      this.sendingSelected.splice(inds, 1);
    }
    EditDailyReport(id:number) {
      const report = this.ddrs.find((d) => d.id == id);
      this.$emit("editingReportChanged",report);
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.ddrs.map((report: any) => ({id: report.id}))
        } else {
            this.selectedRows = []
        }
    }

    deleteDailyReport(payload: number[]) {
        return this.$store.dispatch('DailyReportModule/deleteDailyReport', payload)
    }

    deleteReportPrompt(selectedId: any){
      this.selectedDailyReport = this.ddrs.find((d) => d.id == selectedId);
      this.deletePromptProperty = true
    }

    deleteReport() {
      try {
            const isMultipleDelete = this.selectedRows.length;
            const payload = isMultipleDelete 
              ? this.selectedRows.map(row => Number(row.id)) 
              : [Number(this.selectedDailyReport.id)];
            this.deleteDailyReport(payload).then(() => {})
            this.$bvToast.toast(isMultipleDelete ? 'Reports deleted successfully!' : 'Report deleted successfully!', {
              title: 'Success',
              variant: 'success',
              autoHideDelay: 1000,
              appendToast: true,
              toaster: 'b-toaster-bottom-right',
              solid: true,
            });
          } catch (error) {
            this.$bvToast.toast('Failed to delete report!', {
              title: 'Error',
              autoHideDelay: 1000,
              appendToast: true,
              toaster: 'b-toaster-bottom-right',
              solid: true,
              variant: 'danger'
            });
          }
    }

    ShowEditIcon(id:number):boolean{
      const report = this.ddrs.find((d) => d.id == id);
      var reportDate:any = new Date(report.reportUploadDate).getDate();
      var presentDate:any = new Date(Date.now()).getDate();
      const time = presentDate - reportDate;
      if(time==0){
        return true;
      }
      return false
    }

    getActivityNames(activityLog: any) {
      if (!activityLog.length) return '';
      const uniqueNames = [...new Set(activityLog.map((log:any) => log.activityName).filter(Boolean))];
      return uniqueNames.length > 1 ? uniqueNames.join(' / ') : uniqueNames[0] || '';
    }

    get currentUnitSystem(){
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }
    get ddrs(): Array<any> {
      const report = this.$store.getters["DailyReportModule/getReportsForProject"](
        this.projectId
      );
      const sortedReport = report.slice().sort((a:any, b:any) => {
        const dateA = new Date(a.reportDate);
        const dateB = new Date(b.reportDate);
        return dateA.getTime() - dateB.getTime();
      });
      return sortedReport;
    }
    get selectedProject(): any {
      return this.$store.getters["projectModule/getProjectById"](
        this.projectId
      );
    }
    get allUsers(): any {
      return this.$store.getters["usersModule/fillteredUsers"]("", -1);
    }
    get getSelectedUsers(): any {
      return this.$store.getters["DailyReportModule/getReportRecipient"];
    }
    get filterSelected(): any {
      return this.selectedEmails.filter((x: any) => {
        return x.userEmail
          .toLowerCase()
          .match(this.searchSelected.toLowerCase());
      });
    }
    get filterAll(): any {
      return this.emails.filter((x: any) => {
        return x.userEmail.toLowerCase().match(this.searchAll.toLowerCase());
      });
    }
    get stickyHeaderHeight(): any {
      return `calc(100vh - 210px)`;
    }
    get milestoneActivity():any{
      return this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
    }
    mounted() {            
      this.milestoneActivity;
      this.$store.dispatch("ActivityModule/fetchActivities", this.projectId);
      this.$store.dispatch(
        "DailyReportModule/getReportsForProject", this.projectId).then(res=> {
      });
      if (this.getSelectedUsers.length < 1) {
        this.fetchReportRecipients().then((res: any) => {
          this.selectedEmails = res.data.data;
          this.selectedEmails = this.selectedEmails.map((x: any) => {
            return {
              id: x.userId,
              userEmail: x.userEmail,
            };
          });
          this.sendingSelected = this.selectedEmails.map((x: any) => {
            return {
              id: x.id,
              userEmail: x.userEmail,
            };
          });
        });
      }
      if (this.allUsers.length < 1) {
        this.getUsers().then((res: any) => {
          res.data.data.forEach((el: any) => {
            if (this.selectedEmails.findIndex((x: any) => x.id == el.id) < 0) {
              this.emails.push({
                id: el.id,
                userEmail: el.email,
              });
            }
          });
        });
      } else {
        this.allUsers.forEach((el: any) => {
          if (this.selectedEmails.findIndex((x: any) => x.id == el.id) < 0) {
            this.emails.push({
              id: el.id,
              userEmail: el.email,
            });
          }
        });
      }
    }
  }
  